export const VISA = (props) => {
  const { size = 30, onClick, verticalAlign, marginLeft, marginRight, top, color, className } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 30 30'>
        <g clipPath='url(#clip0_2934_6681)'>
          <rect width={size} height={size} fill='#fff' rx='2'></rect>
          <path
            fill='#1434CB'
            d='M14.854 10.308l-2.004 9.37h-2.425l2.005-9.37h2.424zm10.199 6.05l1.276-3.518.734 3.518h-2.01zm2.705 3.32H30l-1.958-9.37h-2.068c-.466 0-.859.27-1.033.687l-3.637 8.683h2.546l.505-1.4h3.11l.293 1.4zM21.43 16.62c.01-2.473-3.418-2.61-3.395-3.715.007-.336.327-.693 1.027-.785.348-.044 1.305-.08 2.391.42l.425-1.988a6.534 6.534 0 00-2.268-.414c-2.396 0-4.082 1.273-4.095 3.097-.016 1.349 1.204 2.101 2.12 2.55.946.46 1.263.754 1.258 1.164-.006.63-.753.907-1.45.918-1.219.019-1.926-.33-2.489-.592l-.44 2.054c.567.26 1.613.486 2.695.497 2.548 0 4.214-1.258 4.221-3.206zm-10.04-6.311l-3.928 9.37H4.9L2.967 12.2c-.117-.46-.22-.629-.576-.823C1.808 11.06.846 10.764 0 10.58l.057-.272h4.125c.526 0 .998.35 1.119.955l1.02 5.422 2.522-6.377h2.547z'
          ></path>
        </g>
        <defs>
          <clipPath id='clip0_2934_6681'>
            <rect width={size} height={size} fill='#fff' rx='2'></rect>
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
